import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function CollectionEndpointUrlField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (/^http(s?):\/\//i.test(newValue)) {
      setError(false);
    } else {
      setError(`Invalid Endpoint URL`);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Endpoint URL'
          id='endpoint_url'
          aria-describedby='endpoint-url-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='endpoint-url-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='endpoint-url-helper-text'>
            Enter the endpoint url of the storage location
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
